import axios from "axios";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import ReactTost from "../../ReactTost";

import Loader from "../../Loader";
import { useTranslation } from "react-i18next";

const UserDocDelete = (props) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const {t} = useTranslation();
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const[loading,setLoading]=useState(false)

  function deleteDoc(id) {
    if (id) {
      setLoading(true)
      axios
        .delete(`${API_URL}/${API_VERSION}/user_doc/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setLoading(false)
          
          setType("Success");
          setMessage(t("You Doc is deleted."));
          setShowAlert(true);
         
          props.onHide();
          //props.getDoc();
        })
        .catch((error) => {
          setType("Danger");
          setMessage(t("Something went to wrong"));
          setShowAlert(true);
        });
    }
  }

  return (
    <>
      <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />

      {loading ? <Loader/> :
      <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{t("Delete Document")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t("Are you sure you want to delete your Document? This action cannot be undone.")}</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="button" onClick={props.onHide}>
            {t("Cancel")}
          </button>
          <button className="button color_orange" onClick={() => deleteDoc(props.id)}>{t("Delete")}</button>
        </Modal.Footer>
      </Modal>
}
    </>
  );
};

export default UserDocDelete;
